
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vucW", function(module, exports) {

$parcel$export(module.exports, "NudgeBundledUsersXflow", () => $0e9969df0dc9c649$export$77e873b657cd17de);

var $5uXOq = parcelRequire("5uXOq");

var $gwejS = parcelRequire("gwejS");
var $jovBr = parcelRequire("jovBr");
var $lb7qa = parcelRequire("lb7qa");

var $jnhNB = parcelRequire("jnhNB");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $gOHSJ = parcelRequire("gOHSJ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $5GDqD = parcelRequire("5GDqD");

var $2LwjF = parcelRequire("2LwjF");

var $796kT = parcelRequire("796kT");

var $lyjFC = parcelRequire("lyjFC");

var $ayC7S = parcelRequire("ayC7S");

var $7UfZB = parcelRequire("7UfZB");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $0e9969df0dc9c649$var$CONFLUENCE_URL = `https://${window.location.hostname}/wiki/`;
const $0e9969df0dc9c649$var$END_RANGE = 31;
const $0e9969df0dc9c649$var$START_RANGE = 7;
const $0e9969df0dc9c649$var$isActive7to30DaysAgo = (accountCreationDate)=>{
    const date = new Date(accountCreationDate);
    if (!(0, $jovBr.default)(date)) return false;
    const today = new Date();
    return (0, $lb7qa.default)(today, {
        start: (0, $gwejS.default)(date, $0e9969df0dc9c649$var$START_RANGE),
        end: (0, $gwejS.default)(date, $0e9969df0dc9c649$var$END_RANGE)
    });
};
const $0e9969df0dc9c649$export$77e873b657cd17de = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const flagId = (0, $5uXOq.useRef)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [traits, { fetchTraits: fetchTraits }] = (0, $5GDqD.useTraits)();
    const [permitted, setPermitted] = (0, $5uXOq.useState)(false);
    const [state, actions] = (0, $lyjFC.useFlagDismissed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isReminderNudge = actions.canReShowFlag();
    (0, $5uXOq.useEffect)(()=>{
        fetchTraits([
            'SITE_USER'
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        accountId,
        cloudId,
        fetchTraits
    ]);
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('cc_onboarding_nudge_paid_bundled_users');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const jiraFirstActive = (0, $2LwjF.getTraitByName)(traits, 'jira_first_active')?.value;
    const passesAgeCondition = typeof jiraFirstActive === 'string' ? $0e9969df0dc9c649$var$isActive7to30DaysAgo(jiraFirstActive) : false;
    const confluenceFirstActiveDate = (0, $2LwjF.getTraitByName)(traits, 'confluence_first_active')?.value;
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            const confluenceAccess = await (0, $796kT.checkIfUserHasPermissionToAccessConfluence)(cloudId);
            setPermitted(confluenceAccess.permitted);
        };
        if (passesAgeCondition && !confluenceFirstActiveDate) fetchData();
    }, [
        cloudId,
        confluenceFirstActiveDate,
        passesAgeCondition
    ]);
    const isEligibleUser = passesAgeCondition && // jira_first_active + 7 < today < jira_first_active + 31
    !confluenceFirstActiveDate && // should not have logged into confluence
    permitted; // should have confluence access
    const skipRecommendedUsersCall = cohort !== 'experiment' || !isEligibleUser || state.hasBeenDismissed && !isReminderNudge;
    const { loading: loading, recommendedUsers: recommendedUsers } = (0, $ayC7S.useGetRecommendedUsers)(skipRecommendedUsersCall);
    (0, $5uXOq.useEffect)(()=>{
        passesAgeCondition && !confluenceFirstActiveDate && (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'traits loaded', {
            jiraFirstActive: jiraFirstActive,
            confluenceFirstActiveDate: confluenceFirstActiveDate,
            permitted: permitted
        });
    }, [
        confluenceFirstActiveDate,
        createAnalyticsEvent,
        isEligibleUser,
        jiraFirstActive,
        passesAgeCondition,
        permitted
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        isEligibleUser && flagId.current == null && !loading && (0, $6s1PB.expValEquals)('cc_onboarding_nudge_paid_bundled_users', 'cohort', 'experiment') && (!state.hasBeenDismissed || isReminderNudge // should not have dismissed the flag (control lacks this condition)
        )) {
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOHSJ.JiraCommonFlag), {
                        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
                        id: flagId,
                        ...recommendedUsers?.length ? {
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
                                appearance: "stack",
                                data: recommendedUsers,
                                maxCount: 2
                            })
                        } : null,
                        messageId: "nudge-bundled-users-to-join-connie.ui.flag.nudge-flag",
                        messageType: "engagement",
                        testId: "nudge-bundled-users-to-join-connie.ui.nudge-flag",
                        title: formatMessage((0, $7UfZB.default).title),
                        description: formatMessage((0, $7UfZB.default).description),
                        flagType: "info",
                        isAutoDismiss: false,
                        actions: [
                            {
                                content: formatMessage((0, $7UfZB.default).joinButton),
                                onClick: ()=>{
                                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'nudgeBundledUserFlagAction', {
                                        isReminderNudge: isReminderNudge
                                    });
                                    flagId.current && dismissFlag(flagId.current);
                                    actions.dismiss();
                                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                    window.open($0e9969df0dc9c649$var$CONFLUENCE_URL, '_blank');
                                }
                            }
                        ],
                        onDismissed: ()=>{
                            if (flagId.current) {
                                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'nudgeBundledUserFlagAction', {
                                    isReminderNudge: isReminderNudge
                                });
                                dismissFlag(flagId.current);
                                actions.dismiss();
                            }
                        },
                        ...props
                    })
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag viewed', 'nudgeBundledUserFlag', {
                isReminderNudge: isReminderNudge
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        formatMessage,
        showFlag,
        isReminderNudge,
        actions,
        isEligibleUser,
        recommendedUsers,
        loading,
        state.hasBeenDismissed
    ]);
    return null;
};

});
parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraitsOld = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraitsNew = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId && (0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId && (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraits = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api') || (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $5e4cf08f88a8a143$var$fetchTraitsNew, $5e4cf08f88a8a143$var$fetchTraitsOld);
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("796kT", function(module, exports) {

$parcel$export(module.exports, "checkIfUserHasPermissionToAccessConfluence", () => $7d0e91034555a132$export$fe9cdfed60649389);

var $7f4tk = parcelRequire("7f4tk");
const $7d0e91034555a132$export$fe9cdfed60649389 = async (cloudId)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("lyjFC", function(module, exports) {

$parcel$export(module.exports, "useFlagDismissed", () => $7774ed11de7c2539$export$d86ee142b28d8c2f);

var $5uXOq = parcelRequire("5uXOq");

var $gwejS = parcelRequire("gwejS");
var $79nXx = parcelRequire("79nXx");

var $bSSG7 = parcelRequire("bSSG7");
const $7774ed11de7c2539$var$LOCAL_STORAGE_NAMESPACE = 'nudge-bundle-users';
const $7774ed11de7c2539$var$storage = (0, $bSSG7.createLocalStorageProvider)($7774ed11de7c2539$var$LOCAL_STORAGE_NAMESPACE);
const $7774ed11de7c2539$var$storageKey = 'flag-dismissed';
const $7774ed11de7c2539$var$ADD_DAYS = 14;
const $7774ed11de7c2539$export$d86ee142b28d8c2f = ()=>{
    const [hasBeenDismissed, setHasBeenDismissed] = (0, $5uXOq.useState)(Boolean($7774ed11de7c2539$var$storage.get($7774ed11de7c2539$var$storageKey)));
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setHasBeenDismissed(true);
        $7774ed11de7c2539$var$storage.set($7774ed11de7c2539$var$storageKey, Date.now());
    }, [
        setHasBeenDismissed
    ]);
    const canReShowFlag = (0, $5uXOq.useCallback)(()=>{
        let canShowFlag = false;
        if (hasBeenDismissed) {
            const dismissDate = $7774ed11de7c2539$var$storage.get($7774ed11de7c2539$var$storageKey);
            if ((0, $79nXx.default)(Date.now(), (0, $gwejS.default)(dismissDate, $7774ed11de7c2539$var$ADD_DAYS))) canShowFlag = true;
        }
        return canShowFlag;
    }, [
        hasBeenDismissed
    ]);
    return [
        {
            hasBeenDismissed: hasBeenDismissed
        },
        {
            dismiss: dismiss,
            canReShowFlag: canReShowFlag
        }
    ];
};

});

parcelRegister("ayC7S", function(module, exports) {

$parcel$export(module.exports, "useGetRecommendedUsers", () => $42d50853fb7c9725$export$6e3f02729062237b);

var $5uXOq = parcelRequire("5uXOq");

var $7f4tk = parcelRequire("7f4tk");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $42d50853fb7c9725$export$6e3f02729062237b = (skip)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [data, setData] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const searchQuery = {
            context: {
                contextType: 'Generic',
                principalId: accountId,
                siteId: cloudId,
                productKey: 'jira'
            },
            searchQuery: {
                queryString: '',
                customQuery: '',
                minimumAccessLevel: 'SITE'
            },
            maxNumberOfResults: 2
        };
        const getRecommendedUser = async ()=>{
            try {
                const response = await (0, $7f4tk.default)('/gateway/api/v1/recommendations', {
                    method: 'POST',
                    body: JSON.stringify(searchQuery),
                    headers: {
                        Accept: 'application/json'
                    }
                });
                const mappedUsers = response.recommendedUsers?.map(({ id: id, name: name, avatarUrl: avatarUrl })=>({
                        key: id,
                        name: name,
                        href: '#',
                        src: avatarUrl
                    }));
                setData({
                    recommendedUsers: mappedUsers,
                    errors: response.errors
                });
            } catch (error) {
                setData({
                    errors: [
                        error
                    ],
                    recommendedUsers: []
                });
            } finally{
                setLoading(false);
            }
        };
        if (!skip) getRecommendedUser();
    }, [
        accountId,
        skip,
        cloudId
    ]);
    return {
        errors: data?.errors,
        recommendedUsers: data?.recommendedUsers,
        loading: skip ? false : loading
    };
};

});

parcelRegister("7UfZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3904dec9cf6f9344$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3904dec9cf6f9344$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "nudge-bundled-users-to-join-connie.title",
        "defaultMessage": "Your team is working in Confluence"
    },
    description: {
        "id": "nudge-bundled-users-to-join-connie.description",
        "defaultMessage": "Don\u2019t miss out on the conversations happening between your collaborators!"
    },
    joinButton: {
        "id": "nudge-bundled-users-to-join-connie.join-button",
        "defaultMessage": "Access Confluence for free"
    }
});

});



//# sourceMappingURL=async-nudge-bundled-users-flag.aee2b604.js.map
